@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package farmatch.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainDrawable0 {
  public val compose_multiplatform: DrawableResource by 
      lazy { init_compose_multiplatform() }

  public val farmatch_logo: DrawableResource by 
      lazy { init_farmatch_logo() }

  public val farmatch_logo_00: DrawableResource by 
      lazy { init_farmatch_logo_00() }
}

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", CommonMainDrawable0.compose_multiplatform)
  map.put("farmatch_logo", CommonMainDrawable0.farmatch_logo)
  map.put("farmatch_logo_00", CommonMainDrawable0.farmatch_logo_00)
}

internal val Res.drawable.compose_multiplatform: DrawableResource
  get() = CommonMainDrawable0.compose_multiplatform

private fun init_compose_multiplatform(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:compose_multiplatform",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/drawable/compose-multiplatform.xml", -1, -1),
    )
)

internal val Res.drawable.farmatch_logo: DrawableResource
  get() = CommonMainDrawable0.farmatch_logo

private fun init_farmatch_logo(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:farmatch_logo",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/drawable/farmatch_logo.png", -1, -1),
    )
)

internal val Res.drawable.farmatch_logo_00: DrawableResource
  get() = CommonMainDrawable0.farmatch_logo_00

private fun init_farmatch_logo_00(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:farmatch_logo_00",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/farmatch.composeapp.generated.resources/drawable/farmatch_logo_00.png", -1, -1),
    )
)
